import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Formik, Form } from 'formik'
import {
  Typography, Button, TextField, Grid,
} from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import * as Yup from 'yup'
import { useNavigate } from 'react-router-dom'
import { selectorLoading } from '../../../app/slices/loadingSlice'
import { resetPasswordConfirm, selectResetPasswordForm, resetPasswordByUsername } from '../../../app/slices/userSlice'
import InputTimer from '../InputTimer'

const initialValues = {
  code: '',
  newPassword: '',
}

const useStyles = makeStyles((theme) => ({
  paperForm: {
    padding: theme.spacing(1, 2),
  },
  titleSection: {
    marginTop: theme.spacing(4),
    width: '100%',
    fontSize: '18px',
  },
  item: {
    padding: theme.spacing(1.5, 0),
  },
  newPassword: {
    height: theme.spacing(9),
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    margin: theme.spacing(2, 0),
  },
  buttonSend: {
    width: '100%',
    backgroundColor: '#f9b233',
    color: '#ffffff',
    fontSize: '18px',
    padding: '16px 0',
    borderRadius: '10px',
  },
}))

const SendCodeStep = () => {
  const { t } = useTranslation()
  const classes = useStyles()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const loading = useSelector(selectorLoading)
  const resetPasswordForm = useSelector(selectResetPasswordForm)
  const [finishTime, setFinishTime] = React.useState(false)

  const handleSend = (fields) => {
    const formData = {
      userName: resetPasswordForm.userName,
      verifyCode: fields.code,
      newPassword: fields.newPassword,
    }
    dispatch(resetPasswordConfirm(t, formData, () => { navigate('/login', { replace: true }) }))
  }

  const handleResendCode = () => {
    dispatch(resetPasswordByUsername(t, resetPasswordForm, () => setFinishTime(false)))
  }

  const validationSchema = Yup.object().shape({
    code: Yup.string()
      .length(6, t('codeـmustـbeـsix_characters'))
      .required(`${t('code')} ${t('required')}`),
    newPassword: Yup.string()
      .min(8, t('passwordـmustـbeـatـleast_eight_characters'))
      .max(255)
      .required(`${t('password')} ${t('required')}`),
  })

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(fields) => handleSend(fields)}
    >
      {(formikProps) => {
        const {
          errors,
          handleBlur,
          handleChange,
          touched,
          values,
        } = formikProps
        return (
          <Form>
            <Grid
              container
              justify="center"
              direction="row"
              alignItems="center"
              style={{ margin: '0 auto' }}
            >
              <Typography
                variant="h4"
                classes={{ root: classes.titleSection }}
              >
                {t('enter_recived_code_and_new_password')}
              </Typography>
              <Grid item xs={12} classes={{ root: classes.item }}>
                <InputTimer
                  {...formikProps}
                  finishTimeState={[finishTime, setFinishTime]}
                  handleResendCode={handleResendCode}
                />
              </Grid>
              <Grid item xs={12} classes={{ root: classes.item }}>
                <TextField
                  classes={{ root: classes.newPassword }}
                  error={Boolean(touched.newPassword && errors.newPassword)}
                  dir="rtl"
                  InputLabelProps={{ dir: 'ltr' }}
                  helperText={touched.newPassword && errors.newPassword}
                  // label={t('new_Password')}
                  placeholder={t('new_Password')}
                  margin="normal"
                  name="newPassword"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="password"
                  value={values.newPassword}
                  variant="outlined"
                  fullWidth
                />
              </Grid>
            </Grid>
            <Grid classes={{ root: classes.buttonContainer }}>
              <Button
                variant="contained"
                // color="primary"
                classes={{ root: classes.buttonSend }}
                type="submit"
                size="large"
                disabled={!!loading || finishTime}
              >
                {t('send')}
              </Button>
            </Grid>
          </Form>
        )
      }}
    </Formik>
  )
}

SendCodeStep.propTypes = {
}

export default SendCodeStep
